// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 634 ? "2c796e83" : chunkId) + "." + {"634":"ddf23a59462b635a","767":"05255cae7bb42cc7"}[chunkId] + ".js";
};